require('./hireCardNameSelector.scss');

// @ vendors
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const React = require('react');
const classNames = require('classnames');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
// @ actions
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
// @ commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ components
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';

const {
    PROC_CARD_CHANGE_NAME,
    PROC_END,
    PROC_START,
    recordLink,
} = require('utilities/tagging');

class HireCardNameSelector extends React.Component {
    constructor(props) {
        super(props);

        this.handleChangeSelectName = this.handleChangeSelectName.bind(this);
    }

    componentDidMount() {
        const {
            getHireCardNames,
            immHireCardNameSelector,
        } = this.props;

        if (!immHireCardNameSelector.get('fetchSuccess')) {
            getHireCardNames();
        }
    }

    handleChangeSelectName(event) {
        const {
            setSelectedIndex,
        } = this.props;
        recordLink(PROC_CARD_CHANGE_NAME, PROC_END);
        setSelectedIndex(event.value);
    }

    getOptions() {
        const { immHireCardNameSelector } = this.props;

        return immHireCardNameSelector.get('names').toJS().map((name, index) => ({
            label: name,
            value: index
        }));
    }

    render() {
        const {
            borderTop,
            immHireCardNameSelector,
        } = this.props;
        const options = this.getOptions();
        const nameSelectorClass = classNames('hire-card-name-selector',
            { 'hire-card-name-selector--border-top': borderTop });
        let content = null;

        if (immHireCardNameSelector.get('isFetching')) {
            content = <LoadingSection />;
        } else if (immHireCardNameSelector.get('names').size > 1) {
            content = (
                <section className={nameSelectorClass}>
                    <ContactCenterRender>
                        {!isPrintOfficeMode() &&
                            <div className="row">
                                <BlockInfo extraClass="hire-card-name-selector__block-info">
                                    <FormattedText value="cc_hireCardNameSelector-hireCardNameSelector_selectName" />
                                </BlockInfo>
                            </div>
                        }
                    </ContactCenterRender>
                    <div className="row">
                        <div className="col-md-7 hire-card-name-selector__select-container">
                            <OKSelect
                                label="hireCardNameSelector-hireCardNameSelector_subtitle"
                                onChange={this.handleChangeSelectName}
                                onOpen={() => recordLink(PROC_CARD_CHANGE_NAME, PROC_START)}
                                options={options}
                                value={immHireCardNameSelector.get('selectedIndex')}
                            />
                        </div>
                    </div>
                </section>
            );
        }

        return content;
    }
}

HireCardNameSelector.propTypes = {
    borderTop: PropTypes.bool,
    getHireCardNames: PropTypes.func.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    setSelectedIndex: PropTypes.func.isRequired,
};

HireCardNameSelector.defaultProps = {
    borderTop: false,
};

export default connect(null,
    {
        getHireCardNames: hireCardNameSelectorActions.getHireCardNames,
        setSelectedIndex: hireCardNameSelectorActions.setSelectedIndex,
    }
)(HireCardNameSelector);

